import React, { useState } from "react";
import { counties } from "./counties";
import { services } from "./services";

function ContactSection() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [county, setCounty] = useState("");
    const [service, setService] = useState("");
    const [contactType, setContactType] = useState("");
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState({});

    const validateFields = () => {
        const newErrors = {};
        
        if (!name.trim()) newErrors.name = true;
        if (!email.trim()) newErrors.email = true;
        if (!phoneNumber.trim()) newErrors.phoneNumber = true;
        if (!county.trim()) newErrors.county = true;
        if (!service.trim()) newErrors.service = true;
        if (!contactType.trim()) newErrors.contactType = true;
        if (!message.trim()) newErrors.message = true;
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateFields()) {
            return;
        }

        try {
            const response = await fetch('https://formspree.io/f/xpwjggkv', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: name,
                    email: email,
                    phone: phoneNumber,
                    county: county,
                    service: service,
                    contactType: contactType,
                    message: message
                })
            });

            if (response.ok) {
                alert('Message sent successfully!');
                // Reset form
                setName("");
                setEmail("");
                setPhoneNumber("");
                setCounty("");
                setService("");
                setContactType("");
                setMessage("");
                setErrors({});
                console.log("@@Success!");
            } else {
                alert('Failed to send message. Please try again.');
            }
        } catch (error) {
            console.log("<== Error ==>", error);
            alert('Failed to send message. Please try again.');
        }
    };

    const handleFieldChange = (field, value, setter) => {
        setter(value);
        // Clear error when user starts typing
        if (errors[field] && value.trim()) {
            setErrors(prev => ({ ...prev, [field]: false }));
        }
    };

    return (
        <div className="pt-10 w-full w-full max-w-[1280px] mx-auto px-4 2xl:px-0">
            {/* Section Header */}
            <div className="text-center mb-8">
                <h2 className="text-2xl md:text-3xl font-semibold my-2">Contact Us</h2>
                <div className="border-b-4 border-green-600 w-24 mx-auto" />
            </div>

            <div className="flex flex-col gap-10">
                {/* Form */}
                <form onSubmit={handleSubmit} className="flex flex-col gap-6 w-[90%] md:w-[70%] mx-auto">
                    {/* Top row 1 */}
                    <div className="flex flex-col md:flex-row gap-6">
                        <div className="flex flex-col w-full">
                            <label className="font-medium">Name</label>
                            <input
                                type="text"
                                placeholder="Name e.g John Doe"
                                value={name}
                                onChange={(e) => handleFieldChange('name', e.target.value, setName)}
                                className={`border rounded px-4 py-2 mt-2 ${errors.name ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                            />
                        </div>
                        <div className="flex flex-col w-full">
                            <label className="font-medium">Email</label>
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => handleFieldChange('email', e.target.value, setEmail)}
                                className={`border rounded px-4 py-2 mt-2 ${errors.email ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                            />
                        </div>
                    </div>

                    {/* Top row 2 */}
                    <div className="flex flex-col md:flex-row gap-6">
                        <div className="flex flex-col w-full">
                            <label className="font-medium">Phone Number</label>
                            <input
                                type="text"
                                placeholder="Format: +2547********"
                                value={phoneNumber}
                                onChange={(e) => handleFieldChange('phoneNumber', e.target.value, setPhoneNumber)}
                                className={`border rounded px-4 py-2 mt-2 ${errors.phoneNumber ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                            />
                        </div>
                        <div className="flex flex-col w-full">
                            <label className="font-medium">County of Residence</label>
                            <input
                                type="text"
                                list="counties"
                                placeholder="Pick your county"
                                value={county}
                                onChange={(e) => handleFieldChange('county', e.target.value, setCounty)}
                                className={`border rounded px-4 py-2 mt-2 ${errors.county ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                            />
                            <datalist id="counties">
                                {counties.map((county, index) => (
                                    <option value={county} key={index} />
                                ))}
                            </datalist>
                        </div>
                    </div>

                    {/* Top row 3 */}
                    <div className="flex flex-col md:flex-row gap-6">
                        <div className="flex flex-col w-full">
                            <label className="font-medium">Service</label>
                            <input
                                type="text"
                                list="services"
                                placeholder="Pick a service"
                                value={service}
                                onChange={(e) => handleFieldChange('service', e.target.value, setService)}
                                className={`border rounded px-4 py-2 mt-2 ${errors.service ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                            />
                            <datalist id="services">
                                {services.map((service, index) => (
                                    <option value={service} key={index} />
                                ))}
                            </datalist>
                        </div>
                        <div className="flex flex-col w-full">
                            <label className="font-medium">Contact Type</label>
                            <input
                                type="text"
                                list="contactTypes"
                                placeholder="Contact Type"
                                value={contactType}
                                onChange={(e) => handleFieldChange('contactType', e.target.value, setContactType)}
                                className={`border rounded px-4 py-2 mt-2 ${errors.contactType ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                            />
                            <datalist id="contactTypes">
                                <option value="Inquiry" />
                                <option value="Schedule" />
                            </datalist>
                        </div>
                    </div>

                    {/* Message */}
                    <div className="flex flex-col">
                        <label className="font-medium">Message</label>
                        <textarea
                            placeholder="Message"
                            value={message}
                            onChange={(e) => handleFieldChange('message', e.target.value, setMessage)}
                            className={`border rounded px-4 py-2 mt-2 h-28 resize-none ${errors.message ? 'border-red-500 bg-red-50' : 'border-gray-300'}`}
                        />
                    </div>
                    
                    {/* Submit Button */}
                    <div className="flex justify-center">
                        <button
                            type="submit"
                            className="px-8 py-3 rounded text-lg border border-blue-500 bg-blue-500 text-white hover:bg-white hover:!text-blue-500 hover:!border-blue-500 transition"
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ContactSection;